import { render, staticRenderFns } from "./DepartmentStatus.vue?vue&type=template&id=d65d95b0&scoped=true"
import script from "./DepartmentStatus.vue?vue&type=script&lang=js"
export * from "./DepartmentStatus.vue?vue&type=script&lang=js"
import style0 from "./DepartmentStatus.vue?vue&type=style&index=0&id=d65d95b0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65d95b0",
  null
  
)

export default component.exports